import { makeAutoObservable } from "mobx";
import { PProductTypePackagingFeeChoice } from "./PProductTypePackagingFeeChoice";
import { translate, t } from "../I18n";
import { getDepositIcon } from "./PDepositIcon";
export class PProductTypePackagingFeeCreator {
    constructor(params) {
        this.localizationProvider = params.localizationProvider;
        this.domain = params.domain;
        makeAutoObservable(this);
    }
    get isVisible() {
        return this.choices.length > 0;
    }
    get name() {
        return translate(t.menu.creator.productPackaging);
    }
    get choices() {
        return this.domain.possiblePackagingFeeTypes.objects
            .sorted((a, b) => a.price.cents - b.price.cents)
            .raw.map((domain) => new PProductTypePackagingFeeChoice({
            localizationProvider: this.localizationProvider,
            domain,
            depositIcon: domain.deposit !== null ? getDepositIcon(domain.deposit) : null,
        }));
    }
    isSelected(packagingTypeId) {
        const { selectedPackagingFeeTypeId: selectedPackagingTypeId } = this.domain;
        return ((selectedPackagingTypeId &&
            selectedPackagingTypeId.eq(packagingTypeId)) ||
            false);
    }
    choose(packagingTypeId) {
        this.domain.choose(packagingTypeId);
    }
}
